import { PaintRowDraft } from '../types'

/** При подтверждении красок ячейки без колоранта удаляются и не учитываются. */
export function removeEmptyCells(drafts: PaintRowDraft[]): PaintRowDraft[] {
    return drafts.map(draft => ({
        ...draft,
        colorants: draft.colorants.filter(cell => cell.colorantDocumentId),
    }))
}
